import { publicDataFetch } from '../api';

const RUN_SCOPED_TABLES = new Set([
  'academy_content_gwaacademy',
  'content_evergreen_gwaacademy',
  'content_history_gwaacademy',
  'lab_partners_gwaacademy',
  'passes_gwaacademy',
  'self_letters_gwaacademy',
  'session_entries_gwaacademy'
]);

function getSafeStorageItem(key) {
  try {
    return localStorage.getItem(key) || '';
  } catch (e) {
    return '';
  }
}

function getScope() {
  const departmentId =
    getSafeStorageItem('gwa_current_department_id');
  const sessionId =
    getSafeStorageItem('gwa_current_session_id');
  const runId =
    getSafeStorageItem('gwa_current_run_id');

  return {
    department_id: departmentId,
    session_id: sessionId,
    run_id: runId
  };
}

function requireScope(collection) {
  if (!RUN_SCOPED_TABLES.has(collection)) return {};

  const scope = getScope();

  if (!scope.department_id || !scope.session_id || !scope.run_id) {
    throw new Error(
      'Choose an event run before accessing this module.'
    );
  }

  return scope;
}

function buildQuery(query = {}) {
  const params = new URLSearchParams({
    limit: 1000,
    ...query
  });

  return params.toString();
}

async function request(path, options = {}) {
  const response = await publicDataFetch(path, options);

  if (response?.status !== 'success') {
    throw new Error(
      response?.error || `${options.method || 'GET'} ${path} failed`
    );
  }

  return response;
}

function cleanPayload(data = {}) {
  const { id, ...cleanData } = data;
  return cleanData;
}

export const api = {
  get(collection, query = {}) {
    const scope = requireScope(collection);

    return request(
      `read/${collection}?${buildQuery({ ...query, ...scope })}`
    );
  },

  getUnscoped(collection, query = {}) {
    return request(
      `read/${collection}?${buildQuery(query)}`
    );
  },

  post(collection, data) {
    const scope = requireScope(collection);

    return request(`create/${collection}`, {
      method: 'POST',
      body: JSON.stringify({
        ...cleanPayload(data),
        ...scope
      })
    });
  },

  postUnscoped(collection, data) {
    return request(`create/${collection}`, {
      method: 'POST',
      body: JSON.stringify(cleanPayload(data))
    });
  },

  put(collection, id, data) {
    const scope = requireScope(collection);

    return request(`update/${collection}/${id}`, {
      method: 'PUT',
      body: JSON.stringify({
        ...cleanPayload(data),
        ...scope
      })
    });
  },

  putUnscoped(collection, id, data) {
    return request(`update/${collection}/${id}`, {
      method: 'PUT',
      body: JSON.stringify(cleanPayload(data))
    });
  },

  delete(collection, id) {
    const scope = requireScope(collection);
    const query = buildQuery(scope);

    return request(`delete/${collection}/${id}?${query}`, {
      method: 'DELETE'
    });
  },

  deleteUnscoped(collection, id) {
    return request(`delete/${collection}/${id}`, {
      method: 'DELETE'
    });
  }
};